var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"about container"},[_c('h2',[_vm._v(_vm._s(_vm.$t("home.about_title")))]),_c('div',{staticClass:"about-content"},[_c('img',{staticClass:"about-img",attrs:{"src":require("@/assets/about.jpg"),"alt":"About Us"}}),_c('p',{staticClass:"about-desc"},[_vm._v(_vm._s(_vm.$t("home.about_desc")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }